import React, { useState, useRef, useEffect } from 'react';
import { FaCalendar } from 'react-icons/fa';
import CustomCalendar from '../../commonComp/CustomeCalender'; 

const DatePicker = ({ onDateSelect, initialStartDate, initialEndDate }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [startDate, setStartDate] = useState(initialStartDate);
    const [endDate, setEndDate] = useState(initialEndDate);
    const wrapperRef = useRef(null);

    useEffect(() => {
        setStartDate(initialStartDate);
        setEndDate(initialEndDate);
    }, [initialStartDate, initialEndDate]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);

    const handleDateSelect = (start, end) => {
        setStartDate(start);
        setEndDate(end);
        onDateSelect(start, end);
        setIsOpen(false);
    };

    const formatDateForDisplay = () => {
        const toDisplayFormat = (dateStr) => {
            if (!dateStr) return null;
            const parts = dateStr.split('-');
            if (parts.length === 3) {
                const [year, month, day] = parts;
                return `${day}-${month}-${year}`;
            }
            return dateStr;
        };

        if (!startDate && !endDate) return 'All Dates';

        const startDisplay = toDisplayFormat(startDate);
        const endDisplay = toDisplayFormat(endDate);

        if (startDisplay && !endDisplay) {
            return startDisplay;
        }
        if (startDisplay && endDisplay && startDisplay === endDisplay) {
            return startDisplay;
        }
        if (startDisplay && endDisplay) {
            return `${startDisplay} to ${endDisplay}`;
        }
        return 'All Dates';
    };

    return (
        <div className="relative" ref={wrapperRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center self-start sm:self-center mt-2 sm:mt-0 px-3 py-2 text-sm text-gray-600 bg-white border rounded-lg w-64 font-[Archivo]"
            >
                <FaCalendar className="mr-2" /> {formatDateForDisplay()}
            </button>
            {isOpen && (
                <div className="absolute left-0 md:right-0 md:left-auto mt-2 z-20 w-max animate-fade-in-slide-down font-[Archivo]">
                    <CustomCalendar
                        onDateSelect={handleDateSelect}
                        initialStartDate={startDate}
                        initialEndDate={endDate}
                    />
                </div>
            )}
        </div>
    );
};

export default DatePicker;